/**
 * Return the current URLSegment
 */
const getURLSegment = (path: string) => {
    const segments = getURLSegments(path);

    if (segments[segments.length - 1] === '') {
        return 'home';
    }

    return segments[segments.length - 1];
};

/**
 * Return the URLSegments including the current URLSegment
 * @param path
 */
const getURLSegments = (path: string) => {
    let strSegments = path.startsWith('/') ? path.substring(1) : path;
    strSegments = strSegments.endsWith('/') ? strSegments.substring(0, strSegments.length - 1) : strSegments;

    return strSegments.split('/');
}

/**
 * Return the URLSegments including the current URLSegment
 * @param path
 */
const getURLSegmentsString = (path: string) => {
    let strSegments = path.startsWith('/') ? path.substring(1) : path;
    return strSegments.endsWith('/') ? strSegments.substring(0, strSegments.length - 1) : strSegments;
}

/**
 * The formatter for the all menu of Footer
 * @param allFooterMenu
 */
const getFooterMenu = (allFooterMenu: [StandardPage]) => {
    const resultMenu: any = {
        menu: [],
        side: [],
        bottom: [],
        all: allFooterMenu,
    };

    allFooterMenu.forEach((menu: StandardPage) => {
        // Set header menu on footer
        if (menu.showInFooter === 'menu') {
            // Root level (level-1) menu
            if (menu.parentID === 0) {
                let id = menu.id.toString();
                resultMenu.menu.push({ ...{ [id]: [menu] } });
                // Set submenu that is involved each header menu on footer
            } else {
                resultMenu.menu.forEach((rootMenu: any) => {
                    // Set submenu into parent menu array
                    if (rootMenu[menu.parentID]) {
                        rootMenu[menu.parentID].push({ ...menu });
                    }
                });
            }

            // Set footer side menu
        } else if (menu.showInFooter === 'side') {
            resultMenu.side.push(menu);

            // Set footer bottom text link
        } else {
            resultMenu.bottom.push(menu);
        }
    });

    return resultMenu;
};

/**
 * @param {number} amount
 * @param {string} currencySymbol
 * @returns {string} e.g. "$1,000", "$1,000.90", "$500".
 */
const localeCurrency = (amount: number, currencySymbol: string): string => {
    return currencySymbol + amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        trailingZeroDisplay: "stripIfInteger",
    });
};

const removeHTML = (htmlText: string) => {
    return htmlText.replace(/<[^>]*>?/g, '');
};

export const formatAndAddDecimals = (number: number, decimalsNum: number = 0) => {
    let numberString = number.toFixed(decimalsNum);
    const [integerPart, decimalPart] = numberString.split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (decimalsNum) {
        return `${formattedIntegerPart}.${decimalPart}`;
    }

    return formattedIntegerPart;
}

export {
    getURLSegment,
    getURLSegments,
    getURLSegmentsString,
    getFooterMenu,
    localeCurrency,
    removeHTML,
};
